import {
  KnownSettingsNodeDtoType,
  SettingsNodeDto,
  SettingsNodeDtoType,
  SettingsTreeDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { SettingsFormState, SettingsFormType, SettingsTreeDataRequestType } from './settings-tree-reducer.types';

export function generateInitialFormState(
  nodeId: string,
  nodeType: KnownSettingsNodeDtoType,
  requestType: SettingsTreeDataRequestType,
  formType: SettingsFormType,
  readOnly: boolean = false,
  parentNodeId?: string,
  parentProjectId?: string,
  parentEntityId?: string,
  parentNodeType?: KnownSettingsNodeDtoType,
  data?: Record<string, any>
): SettingsFormState {
  return {
    nodeId,
    parentNodeId,
    parentProjectId,
    parentEntityId,
    parentNodeType,
    nodeType,
    formType,
    requestType,
    form: {},
    readOnly,
    isLoading: false,
    isRegistered: false,
    isTouched: false,
    isSubmitting: false,
    isSuccess: false,
    data
  };
}

// This function should be fairly efficient because each node has at most one parent.
export function findAllAntecedents(
  node: SettingsNodeDto,
  settingsTree: SettingsTreeDto,
  visited: Set<string> = new Set()
): string[] {
  // Avoid cycles by returning early if this node has already been visited
  if (visited.has(node.id)) {
    return [];
  }
  visited.add(node.id);

  const parent = settingsTree.nodes.find((n) => n.id === node.parentId);
  if (!parent) {
    return [];
  }

  const antecedents: string[] = [];
  antecedents.push(parent.id);
  antecedents.push(...findAllAntecedents(parent, settingsTree, visited));
  return antecedents;
}

export function findAllDescendants(
  node: SettingsNodeDto,
  settingsTree: SettingsTreeDto,
  nodeType?: SettingsNodeDtoType
): string[] {
  const children = settingsTree.nodes.filter((n) => n.parentId === node.id && (!nodeType || n.type === nodeType));

  const descendants: string[] = [];
  children.forEach((child) => {
    descendants.push(child.id);
    descendants.push(...findAllDescendants(child, settingsTree, nodeType));
  });
  return descendants;
}
